import { HighlightedQuoteProps } from '@ahc-digital/component-library';
import { getDroplink } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C45HighlightedQuoteProps } from './C45HighlightedQuote.types';

export function CreateHighlightedQuoteModel(
  props?: C45HighlightedQuoteProps
): HighlightedQuoteProps {
  type t = HighlightedQuoteProps;

  const { fields, params } = props || {};
  const { renderRichText, renderImage, renderLink } = useConditionalRendering();

  return {
    quote: renderRichText(fields?.Quote, { required: true }),
    image: renderImage(fields?.Image),
    byline: renderRichText(fields?.Byline),
    cta: renderLink(fields?.Cta),
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    contentAlignment: getDroplink<t['contentAlignment']>(params?.ContentAlignment, 'left'),
    ctaStyle: getDroplink<t['ctaStyle']>(params?.CtaStyle, 'button'),
  };
}
